import { StyledContent } from '@/components/styles';
import { Picture } from '@/components';

const Credo = ({ data, video }) => {
  const { content, image, preview_alt } = data;
  const imageAlt = preview_alt || 'Credo';
  return (
    <>
      {!video && image && Object.keys(image).length > 0 && <Picture {...image} alt={imageAlt} isLazy={true}/>}
      {video && <video autoplay="autoplay" loop="loop" muted="muted" playsinline="playsinline" src={video}></video>}
      {content && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: content }} dark/>
        </StyledContent.Description>
      )}
    </>
  );
};

export default Credo;
